import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    > .LoaderSpin {
        width: 100%;
        height:100%;
        > .ant-spin-container {
            height: 100%;
        }
    }
   
}
`;
